import { render } from "./get-the-app.vue?vue&type=template&id=6d8d1500"
import script from "./get-the-app.vue?vue&type=script&lang=js"
export * from "./get-the-app.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./get-the-app.vue?vue&type=style&index=0&id=6d8d1500&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/r/Desktop/ev-switch-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__